import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={58.8}
    viewBox="0 0 60.5 59.3"
    {...props}
  >
    <defs>
      <style>
        {
          "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #f7f7f7;\n      }\n\n      .cls-3 {\n        fill: #e1e1e1;\n      }\n    "
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
    <g>
      <path class="cls-1" d="M8.7,51.4l7,6.6s4.3,3.4,6.9-1.8,13.9-25.6,13.9-25.6L59.3,7.5s2.5-2.9-.4-5.6-5.2-2-7.1-.8-22.8,21.7-22.8,21.7L2.2,37.7s-3.9,2.4-.6,6.2,7.2,7.6,7.2,7.6Z"/>
      <path class="cls-2" d="M22.2,46.5c-.5.2-1.1.1-1.6-.2-.9-.6-1.3-1.8-.8-2.7l5.4-9.5c.6-.9,1.8-1.3,2.7-.8.9.6,1.3,1.8.8,2.7l-5.4,9.5c-.3.5-.7.8-1.2.9h0Z"/>
      <circle class="cls-2" cx="18.7" cy="49.9" r="2"/>
    </g>
  </g>
  </svg>
);
export default SVGComponent;
